import { useState, useEffect, useRef } from 'react'

export function Fade({ children, delay = 0, y = 18, className, style }) {
  const ref = useRef(null)
  const [vis, setVis] = useState(false)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    // rootMargin: срабатываем за 200px до появления в viewport — анимация завершится до того, как юзер доскроллит
    const ob = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setTimeout(() => setVis(true), delay); ob.disconnect() }
    }, { threshold: 0, rootMargin: '200px 0px' })
    ob.observe(el)
    return () => ob.disconnect()
  }, [delay])
  return (
    <div ref={ref} className={className} style={{
      opacity: vis ? 1 : 0,
      transform: vis ? 'none' : `translateY(${y}px)`,
      transition: `opacity .32s ease ${delay}ms,transform .38s cubic-bezier(.2,.7,.2,1) ${delay}ms`,
      ...style,
    }}>
      {children}
    </div>
  )
}